import React from "react";
import { PaymentConnectionCard } from "../components/setting-payment-connection-card";
import SettingPaymentService, { PaymentPartnersSettingPayload } from "../services/setting-payment-service";

const payOSFields = [
  { name: "client_id", label: "PayOS Client ID", placeholder: "Nhập Client ID" },
  { name: "api_key", label: "PayOS API Key", placeholder: "Nhập API Key" },
  { name: "checksum_key", label: "PayOS Checksum Key", placeholder: "Nhập Checksum Key" },
];

const SettingPaymentIndexPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-start h-full p-4 space-y-8">
      <PaymentConnectionCard<PaymentPartnersSettingPayload>
        title="KẾT NỐI THANH TOÁN QUA PAYOS"
        fields={payOSFields}
        type="payos"
        getDetails={SettingPaymentService.getPaymentDetail}
        updateSettings={SettingPaymentService.settingPayment}
        disconnect={SettingPaymentService.cancelPayment}
      />
    </div>
  );
};

export default SettingPaymentIndexPage;